import { post } from "../utils/backend";
import { Category, HomeShowItem, SetHomeShowRequest } from "../models/CategoryManagement";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/CategoryMock";

const categories: Category[] = getMockData("all_categories");

const getAllCategories = async (): Promise<Category[]> => {
    if (mock) {
        return categories;
    }
    const resultOrErrorCode = await post<null, Category[]>("/managerment/category/getAllCategories", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const updateCategory = async (params: Partial<Category>): Promise<boolean> => {
    if (mock) {
        const category = categories.find(category => category.id === params.id);
        if (category) {
            Object.assign(category, params);
        }
        return true;
    }
    const resultOrErrorCode = await post<Partial<Category>, boolean>("/managerment/category/update", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const addCategory = async (params: Partial<Category>): Promise<boolean> => {
    if (mock) {
        categories.push(params as Category);
        return true;
    }
    const resultOrErrorCode = await post<Partial<Category>, boolean>("/managerment/category/add", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const hideMainCategory = async (categoryId: number): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ id: number }, boolean>("/managerment/category/hideMainCategory", { id: categoryId });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const deleteSecondCategory = async (categoryId: number): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<{ id: number }, boolean>("/managerment/category/deleteSecondCategory", { id: categoryId });
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

const deleteMainCategory = async (categoryId: number): Promise<boolean> => {
    if (mock) {
        const idx = categories.findIndex(c => c.id === categoryId);
        if (idx >= 0) {
            const childIds = categories.filter(c => c.parentId === categoryId).map(c => c.id);
            categories.splice(idx, 1);
            childIds.forEach(id => {
                const i = categories.findIndex(c => c.id === id);
                if (i >= 0) categories.splice(i, 1);
            });
        }
        return true;
    }
    const resultOrErrorCode = await post<{ id: number }, boolean>("/managerment/category/deleteMainCategory", { id: categoryId });
    if (typeof resultOrErrorCode === 'string') {
        return false;
    }
    return resultOrErrorCode;
};

const homeShows: HomeShowItem[] = getMockData("home_shows");

const getHomeShows = async (): Promise<HomeShowItem[]> => {
    if (mock) {
        return homeShows;
    }
    const resultOrErrorCode = await post<null, HomeShowItem[]>("/managerment/category/getHomeShows", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const setHomeShow = async (params: SetHomeShowRequest): Promise<boolean> => {
    if (mock) {
        homeShows.push({ 
            index: params.index,
            secondCategory: categories.find(category => category.id === params.secondCategoryId) as Category
        });
        return true;
    }
    const resultOrErrorCode = await post<SetHomeShowRequest, boolean>("/managerment/category/setHomeShow", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const CategoryApi = {
    getAllCategories,
    updateCategory,
    addCategory,
    hideMainCategory,
    deleteMainCategory,
    deleteSecondCategory,
    getHomeShows,
    setHomeShow
}; 